import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

/**
 Utilities
 **/

/**
 * Bind document uploader
 */
window.initDocumentUploader = function (elem) {
    var _this = elem;
    var document_data = _this.data('document-data');
    var file_input = _this.find('input[type=file]');

    _this.theme = _this.data('theme') || 'admin';
    _this.documentId = document_data.document_id;
    _this.documentType = document_data.document_type;
    _this.progressDisplay = _this.find('.progress');
    _this.progressBar = _this.find('.progress-bar');
    _this.cancelButton = _this.find('.btn-cancel');
    _this.errorDisplay = _this.find('.error-msg');
    _this.fileSelector = _this.find('.fileinput');
    _this.fileDismiss = _this.find('[data-dismiss="fileinput"]');
    _this.deleteButton = _this.find('.btn-delete');
    _this.fileDetails = _this.find('.file-details');

    if (file_input.length) {

        var mime_types = file_input.prop('accept').split(',');

        // hide the error when file dismissed
        _this.fileDismiss.click(function () {
            _this.errorDisplay.hide();
        });

        _this.deleteButton.on('click', function (e) {
            // abort if no document id
            if (!_this.documentId) {
                return;
            }

            e.preventDefault();

            // prompt the user
            Swal.fire({
                title: 'Are you sure?',
                text: 'You will not be able to undo this delete operation!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
            }).then(function (result) {
                if (result.value) {
                    // delete the document
                    $.ajax({
                        url: Laravel.document_upload_url + '/' + _this.documentId,
                        type: 'DELETE',
                        beforeSend: function () {
                            toggleLoading(_this.deleteButton, true);
                        },
                        complete: function () {
                            toggleLoading(_this.deleteButton, false);
                        },
                        success: function (result) {
                            _this.deleteButton.hide();
                            _this.fileDetails.hide();
                            _this.errorDisplay.hide();

                            _this.fileDismiss.trigger('click');
                            _this.fileSelector.show();
                            _this.documentId = null;

                            // delete completely if no document type
                            if (!_this.documentType) {
                                _this.remove();
                            }
                        },
                        error: function (xhr) {
                            if (xhr.status === 422) {
                                showValidationErrorMsg(xhr);
                            } else {
                                _this.errorDisplay.text('Failed to delete the document');
                                _this.errorDisplay.show();
                            }
                        }
                    });
                }
            });

        });

        file_input.change(function (e) {

            // abort if document already uploaded
            if (_this.documentId) {
                return;
            }

            $(this).simpleUpload(Laravel.document_upload_url, {

                allowedTypes: mime_types,
                maxFileSize: Laravel.max_upload_size * 1024, // convert kb to bytes
                data: document_data,

                start: function (file) {
                    //upload started

                    /*
                     * Since "this" differs depending on the function in which it is called,
                     * we need to assign "this" to a local variable to be able to access
                     * this.upload.cancel() inside another function call.
                     */

                    var that = this;

                    _this.cancelButton.click(function (e) {
                        e.preventDefault();
                        that.upload.cancel();
                        //now, the cancel callback will be called
                    });

                    _this.progressDisplay.show();
                    _this.cancelButton.show();
                    _this.errorDisplay.hide();
                    _this.fileSelector.hide();
                },

                progress: function (progress) {
                    //received progress
                    _this.progressBar.width(progress + "%");
                },

                success: function (data) {
                    //upload successful
                    _this.progressDisplay.hide();
                    _this.cancelButton.hide();
                    _this.errorDisplay.hide();
                    _this.fileSelector.hide();

                    _this.documentId = data.id;
                    _this.deleteButton.show();

                    _this.fileDetails.prop('href', data.url);
                    _this.fileDetails.find('i').removeClass().addClass(_this.theme == 'web' ? data.web_icon : data.icon);
                    _this.fileDetails.find('span').text('.' + data.extension + ' ' + data.human_readable_size);
                    _this.fileDetails.show();
                },

                error: function (error) {
                    //upload failed
                    _this.progressDisplay.hide();
                    _this.cancelButton.hide();

                    var error_msg = error.message;

                    if (error.name === 'RequestError') {
                        var status = error.xhr.status;

                        if (status === 413) {
                            error_msg += '. File is too big.';
                        } else if (error.xhr.hasOwnProperty('responseJSON')) {
                            error_msg += '. ' + (error.xhr.responseJSON.error || '');
                        }
                    }

                    _this.fileDismiss.trigger('click');
                    _this.errorDisplay.text(error_msg).show();
                    _this.fileSelector.show();
                },

                cancel: function () {
                    //upload cancelled
                    _this.progressDisplay.hide();
                    _this.cancelButton.hide();
                    _this.errorDisplay.hide();
                    _this.fileDismiss.trigger('click');
                    _this.fileSelector.show();
                }

            });

        });
    }
};


window.getParameterByName = function (name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

$(document).ready(function () {

    $('form[data-ajax-submit]').on('submit', function (e) {
        e.preventDefault();
        var wysiwygElements = document.querySelectorAll('.wysiwyg');
        wysiwygElements.forEach(function(element) {
            var editor = tinymce.get(element.id); // Get the TinyMCE editor instance by element ID
            if (editor) {
                editor.save(); // Call the save method
            }
        });

        // https://jquery.malsup.com/form/#api
        var _this = this;



        // submit the form
        $(this).ajaxSubmit({
            beforeSubmit: function (arr, form, options) {
                togglePreloader(true);
            },

            error: function (xhr) {
                togglePreloader(false);

                if (xhr.status == 422) {
                    showValidationErrorMsg(xhr, $(_this));
                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'An error occurred while saving.',
                        icon: 'error'
                    });
                }
            },



            success: function (response, statusText, xhr, form) {
                var edit_url = response.edit_url;
                var upload_url = response.upload_url;
                var dropzone_elems = form.find('[data-dropzone-delay-submit="true"]');
                var total_dropzones = dropzone_elems.length;
                var processed_dropzones = 0;

                if (total_dropzones > 0) {
                    dropzone_elems.each(function () {
                        var dropzone_obj = Dropzone.forElement(this);

                        dropzone_obj.options.url = upload_url;
                        dropzone_obj.on('queuecomplete', function () {
                            processed_dropzones++;

                            if (processed_dropzones >= total_dropzones) {
                                redirectPage(edit_url);
                            }
                        });

                        if (dropzone_obj.getQueuedFiles().length > 0) {
                            dropzone_obj.processQueue();
                        } else {
                            processed_dropzones++;

                            if (processed_dropzones >= total_dropzones) {
                                redirectPage(edit_url);
                            }
                        }
                    });
                } else {
                    redirectPage(edit_url);
                }
            }
        });

        // return false to prevent normal browser submit and page navigation
        return false;

    });

    $('[data-document-data]').each(function () {
        initDocumentUploader($(this));
    });

    $('.dynamic-documents-table').on('click', '.dynamic-document .btn-delete', function (e) {
        var _this = $(this).closest('.dynamic-document');

        _this.documentId = _this.data('document-data').document_id;
        _this.errorDisplay = _this.find('.error-msg');
        _this.deleteButton = _this.find('.btn-delete');

        // abort if no document id
        if (!_this.documentId) {
            return;
        }

        e.preventDefault();

        // prompt the user
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to undo this delete operation!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
        }).then(function (result) {
            if (result.value) {
                // delete the document
                $.ajax({
                    url: Laravel.document_upload_url + '/' + _this.documentId,
                    type: 'DELETE',
                    beforeSend: function () {
                        toggleLoading(_this.deleteButton, true);
                    },
                    complete: function () {
                        toggleLoading(_this.deleteButton, false);
                    },
                    success: function (result) {
                        _this.deleteButton.hide();
                        _this.errorDisplay.hide();
                        _this.documentId = null;

                        _this.remove();
                    },
                    error: function (xhr) {
                        if (xhr.status === 422) {
                            showValidationErrorMsg(xhr);
                        } else {
                            _this.errorDisplay.text('Failed to delete the document');
                            _this.errorDisplay.show();
                        }
                    }
                });
            }
        });

    });

    $('[data-document-adder]').each(function () {
        var _this = $(this);
        var document_data = _this.data('document-adder');
        var file_input = _this.find('input[type=file]');

        _this.theme = _this.data('theme') || 'admin';
        _this.nameInput = _this.find('input[name="name"]');
        _this.progressDisplay = _this.find('.progress');
        _this.progressBar = _this.find('.progress-bar');
        _this.cancelButton = _this.find('.btn-cancel');
        _this.errorDisplay = _this.find('.error-msg');
        _this.fileSelector = _this.find('.fileinput');
        _this.fileDismiss = _this.find('[data-dismiss="fileinput"]');
        _this.documentsTbody = $(_this.data('documents-table') + ' tbody');

        if (file_input.length) {

            var mime_types = file_input.prop('accept').split(',');

            // hide the error when file dismissed
            _this.fileDismiss.click(function () {
                _this.errorDisplay.hide();
            });

            file_input.change(function (e) {

                var params = document_data;

                if (_this.nameInput.val()) {
                    params.name = _this.nameInput.val();
                }

                $(this).simpleUpload(Laravel.document_upload_url, {

                    allowedTypes: mime_types,
                    maxFileSize: Laravel.max_upload_size * 1024, // convert kb to bytes
                    data: params,

                    start: function (file) {
                        //upload started

                        /*
                         * Since "this" differs depending on the function in which it is called,
                         * we need to assign "this" to a local variable to be able to access
                         * this.upload.cancel() inside another function call.
                         **/

                        var that = this;

                        _this.cancelButton.click(function (e) {
                            e.preventDefault();
                            that.upload.cancel();
                            //now, the cancel callback will be called
                        });

                        _this.progressDisplay.show();
                        _this.cancelButton.show();
                        _this.nameInput.prop('disabled', true);
                        _this.errorDisplay.hide();
                        _this.fileSelector.hide();
                    },

                    progress: function (progress) {
                        //received progress
                        _this.progressBar.width(progress + "%");
                    },

                    success: function (data) {
                        //upload successful
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();
                        _this.errorDisplay.hide();
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                        _this.fileDismiss.trigger('click');

                        var html = '<tr class="dynamic-document">' +

                            '<td data-col="Document">' + data.name + '</td>' +

                            '<td data-col="File">' +
                            '<a href="' + data.url + '" target="_blank" class="file-details">' +
                            '<i class="' + (_this.theme == 'web' ? data.web_icon : data.icon) + '"></i>' +
                            '<span> .' + data.extension + ' ' + data.human_readable_size + '</span>' +
                            '</a>' +

                            '<strong class="mt-2 error-msg text-danger" style="display: none;"></strong>' +
                            '</td>' +

                            '<td class="w-md-small">' +
                            '<a href="#" class="btn-delete btn btn-danger' + (_this.theme == 'admin' ? ' btn--icon-text btn--raised' : '') + '">' +
                            '<i class="' + (_this.theme == 'web' ? 'fa fa-trash' : 'zmdi zmdi-delete') + '"></i> Delete' +
                            '</a>' +
                            '</td>' +
                            '</tr>';

                        var row = $(html);
                        row.data('document-data', {
                            model_id: document_data.model_id,
                            model_type: document_data.model_id,
                            document_id: data.id
                        });

                        _this.documentsTbody.append(row);
                        $('[data-empty-row]').remove();
                    },

                    error: function (error) {
                        //upload failed
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();

                        var error_msg = error.message;

                        if (error.name == 'RequestError') {
                            var status = error.xhr.status;

                            if (status == 413) {
                                error_msg += '. File is too big.';
                            } else if (error.xhr.hasOwnProperty('responseJSON')) {
                                error_msg += '. ' + (error.xhr.responseJSON.error || '');
                            }
                        }

                        _this.fileDismiss.trigger('click');
                        _this.errorDisplay.text(error_msg).show();
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                    },

                    cancel: function () {
                        //upload cancelled
                        _this.progressDisplay.hide();
                        _this.cancelButton.hide();
                        _this.errorDisplay.hide();
                        _this.fileDismiss.trigger('click');
                        _this.fileSelector.show();
                        _this.nameInput.val('');
                        _this.nameInput.prop('disabled', false);
                    }

                });

            });
        }
    });
    /**
     * Update the links on tab select
     */
    if (window.history.replaceState) {
        $(function () {
            $('[data-toggle="tab"]:not(.disabled)').click(function (e) {
                var hash = this.hash;
                var currentUrl = window.location.href;
                if (hash) {
                    var tabVal = hash.substr(1);
                    currentUrl = replaceUrlParam(currentUrl, "tab", tabVal);
                    //prevents browser from storing history with each change:
                    window.history.replaceState({}, null, currentUrl);
                }
            });
        });
    }

    function replaceUrlParam(url, paramName, paramValue) {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
        if (url.search(pattern) >= 0) {
            return url.replace(pattern, '$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/, '');
        return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
    }


    $('[data-edit-iframe-modal]').on('click', function (e) {
        e.preventDefault();

        var url = $(this).prop('href');
        var modal = $($(this).data('edit-iframe-modal'));
        var title = $(this).data('modal-title') || '';

        if (title) {
            modal.find('.modal-title').text(title);
        } else {
            modal.find('.modal-title').hide();
        }

        var iframe = modal.find('iframe');

        iframe.unbind('load');
        iframe.prop('src', url);


        modal.modal('show');
    });



    $('[data-save-iframe]').on('click', function (e) {
        e.preventDefault();

        var _this = this;
        var modal = $(this).closest('.modal');
        var iframe = $($(this).data('save-iframe'));
        var iframe_contents = iframe.contents();
        var form = iframe_contents.find('form');
        var confirm_save = $(this).data('confirm-save') || false;
        var redirect_url = $(this).data('redirect-url');

        if (confirm_save) {
            Swal.fire({
                title: 'Are you sure?',
                text: 'Just checking if you wanted to really do this.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, continue!',
            }).then(function (result) {
                if (result.value) {
                    saveIframe();
                }
            });
        } else {
            saveIframe();
        }

        function saveIframe() {
            toggleLoading($(_this), true);

            iframe.unbind('load');

            iframe.on('load', function () {
                toggleLoading($(_this), false);

                // check for any validation errors
                if (iframe.contents().find('.is-invalid').length < 1) {
                    modal.modal('hide');

                    notify('Success! ', 'Your inputs have been saved.', 'success');

                    // Uncomment if you want to reload whole page instead of only the iframe
                    redirectPage(redirect_url);
                }
            });

            form.submit();
        }
    });

});

if($('.date-picker')[0]) {
    $('.date-picker').flatpickr({
        allowInput: true,
        enableTime: false,
        nextArrow: '<i class="fa fa-long-arrow-right" />',
        prevArrow: '<i class="fa fa-long-arrow-left" />'
    });
}

if ($('.multiple-date-picker')[0]) {
    $('.multiple-date-picker').flatpickr({
        allowInput: true,
        enableTime: false,
        nextArrow: '<i class="fa fa-long-arrow-right" />',
        prevArrow: '<i class="fa fa-long-arrow-left" />',
        mode: "multiple",
    });
}

// Enable the element only when another element is a
// given value
$('[data-enable-value]').each(function () {
    var _this = $(this);
    var value = _this.data('enable-value');
    var element = $(_this.data('enable-elem'));
    var disable_on_select = _this.data('disable') || false;

    if (element.length) {
        element.on('change', function () {
            var curr_val = $(this).val();
            var matching_selected = false;

            if (value instanceof Array) {
                matching_selected = value.findIndex(function (e) {
                    return e == curr_val;
                }) > -1;
            } else {
                matching_selected = curr_val == value;
            }

            var enable = disable_on_select ? (!matching_selected) : matching_selected;

            _this.prop('disabled', !enable);
        }).trigger('change');
    }
});

// Enable the section only when another element is a
// given value
$('[data-enable-section-value]').each(function () {
    var _this = $(this);
    var value = _this.data('enable-section-value');
    var element = $(_this.data('enable-elem'));
    var hide_fields = _this.data('hide-fields') || false;
    var disable_on_select = _this.data('disable') || false;

    if (element.length) {
        element.on('change', function () {
            var curr_val = $(this).val();
            var matching_selected = false;

            if (value instanceof Array) {
                matching_selected = value.findIndex(function (e) {
                    return e == curr_val;
                }) > -1;
            } else {
                matching_selected = curr_val == value;
            }

            var enable = disable_on_select ? (!matching_selected) : matching_selected;

            if (enable) {
                // if enable, enable only auto-disabled
                _this.find('select.auto-disabled:disabled, input.auto-disabled:disabled, textarea.auto-disabled:disabled').each(function () {
                    $(this).prop('disabled', false)
                        .removeClass('auto-disabled');
                });
            } else {
                // if disable, enable only enabled
                _this.find('select:enabled, input:enabled, textarea:enabled').each(function () {
                    $(this).prop('disabled', true)
                        .addClass('auto-disabled');
                });
                _this.find('input:checkbox').each(function () {
                    $(this).prop("checked", false).trigger('change');
                });
            }

            if (hide_fields) {
                if (enable) {
                    _this.slideDown();
                } else {
                    _this.slideUp();
                }
            }
        }).trigger('change');
    }
});

// Enable the section only when another element is a
// given value
$('[data-enable-checkbox]').each(function () {
    var _this = $(this);
    var element = $(_this.data('enable-checkbox'));
    var hide_fields = _this.data('hide-fields') || false;

    if (element.length) {
        element.on('change', function () {
            var is_checked = $(this).is(":checked");

            if (is_checked) {
                // if enable, enable only auto-disabled
                _this.find('select.auto-disabled:disabled, input.auto-disabled:disabled, textarea.auto-disabled:disabled').each(function () {
                    $(this).prop('disabled', false)
                        .removeClass('auto-disabled');
                });
            } else {
                // if disable, enable only enabled
                _this.find('select:enabled, input:enabled, textarea:enabled').each(function () {
                    $(this).prop('disabled', true)
                        .addClass('auto-disabled');
                });
                _this.find('.select2-selection__clear').mousedown();
            }

            if (hide_fields) {
                if (is_checked) {
                    _this.slideDown();
                } else {
                    _this.slideUp();
                }
            }
        }).trigger('change');
    }
});


/* Custom */
$(document).ready(function () {

// Enable the element only when another element is filled or selected
    $('[data-enable-section-on-select]').each(function () {
        let _this = $(this);
        let element = $(_this.data('enable-section-on-select'));

        if (element.length) {
            element.on('change', function () {

                if (element.val()) {
                    _this.prop('disabled', false).removeClass('auto-disabled');
                    _this.slideDown();
                }

                if (!element.val()) {
                    _this.prop('disabled', true).addClass('auto-disabled');
                    _this.slideUp();
                }

            }).trigger('change');
        }
    });

});

import './_dropzone';
